// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N4MAg","col":"styles_col__3A8aV"};